import React from 'react'
import { useRecoilValue, useRecoilCallback } from 'recoil'
import { useIntl } from 'react-intl'
import styled from '@emotion/styled'

import {
  Icon60Arrow2Left,
  Icon60Arrow2Right,
  Flex,
  FlexItem,
  Link,
  LINK_VARIANT_DEFAULT,
  Title,
  TITLE_VARIANT_M
} from 'mailup-web-components'

import { calendarState } from 'Pages/ScheduledSendings/recoil/state/calendar'
import { fetchScheduledCallback } from 'Pages/ScheduledSendings/recoil/callbacks/callbacks'

const StyledIconWrapper = styled.span`
  font-size: 18px;
`

const CalendarNav = () => {
  const { month, canPrev } = useRecoilValue(calendarState)
  const intl = useIntl()
  const fetchScheduled = useRecoilCallback(fetchScheduledCallback, [])
  const handlePrev = () => {
    fetchScheduled({ calendarAction: 'prev' })
  }

  const handleNext = () => {
    fetchScheduled({ calendarAction: 'next' })
  }

  return (
    <Flex alignItems='center'>
      <Link
        variant={LINK_VARIANT_DEFAULT}
        disabled={!canPrev}
        onClick={handlePrev}
      >
        <StyledIconWrapper>
          <Icon60Arrow2Left />
        </StyledIconWrapper>
      </Link>
      <FlexItem width='165px' margin='auto'>
        <Title variant={TITLE_VARIANT_M} textAlign='center'>
          {intl.formatDate(month, {
            year: 'numeric',
            month: 'long',
            timeZone: 'UTC'
          })}
        </Title>
      </FlexItem>
      <Link variant={LINK_VARIANT_DEFAULT} onClick={handleNext}>
        <StyledIconWrapper>
          <Icon60Arrow2Right />
        </StyledIconWrapper>
      </Link>
    </Flex>
  )
}

export default CalendarNav
